import { createRuntimeOperationType } from './common';
export const nullContentNodeReferenceOperationType = createRuntimeOperationType({
    kind: 'NULL_CONTENT_NODE_REFERENCE',
    dependencies: () => [],
    run: () => ({
        kind: 'SCALAR',
        typeName: 'String',
        isNullable: true,
        directives: [],
        state: {},
        getDataTypeConfig: () => ({
            kind: 'SCALAR',
            typeName: 'String',
            isNullable: true,
            directives: [],
            state: {},
            meta: { path: [], unmappedPath: [] },
        }),
        parent: () => undefined,
        meta: { path: [], unmappedPath: [] },
        data: null,
    }),
});
//# sourceMappingURL=null-content-node-reference.js.map